/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { Space, Button, Input, Collapse, Checkbox, DatePicker, Row, Col } from 'antd';
import EbzButton from 'components/EbzButton';
import EbzSelect from 'components/EbzSelect';
import EbzCollapse from 'components/EbzCollapse';
import { AMOUNT_RANGE } from 'constants/transaction';

const { Panel } = Collapse;
const { RangePicker } = DatePicker;

function EbzFilterGroup({ searchParams, filters, apply, clear, ...props }) {
  const [selected, setSelected] = useState(searchParams[0].value);
  const [selectAmountRange, setSelectAmountRange] = useState(AMOUNT_RANGE?.[0]?.value);
  const [amount, setAmount] = useState(null);
  const [search, setSearch] = useState(null);
  const [checkboxGroup, setCheckboxGroup] = useState({});
  const [dateRange, setDateRange] = useState(null);
  const [date, setDate] = useState(null);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);

  const updateFlag = () => {
    if (search || Object.keys(checkboxGroup).length || dateRange || amount || date) {
      setIsApplyDisabled(false);
    } else {
      setIsApplyDisabled(true);
    }
  };

  useEffect(() => {
    updateFlag();
  }, [search, checkboxGroup, dateRange, amount, date]);

  const clearAllFilter = () => {
    setSearch(null);
    setCheckboxGroup({});
    setDateRange(null);
    setDate(null);
    setIsApplyDisabled(true);
    setAmount(null);
    setSelectAmountRange(AMOUNT_RANGE?.[0]?.value);
  };

  const handleSelected = (v) => {
    setSelected(v);
  };

  const handleSearch = (v) => {
    if (selected === 'merchant_id') {
      const re = /^[0-9]+$/;
      if (v.target.value === '' || re.test(v.target.value)) {
        setSearch(v.target.value);
      }
    } else {
      setSearch(v.target.value);
    }
  };

  const handleCheck = (v) => {
    const updatedCheckboxGroup = {
      ...checkboxGroup,
      ...v
    };

    const finalChecboxGroup = Object.keys(updatedCheckboxGroup).reduce((acc, key) => {
      if (updatedCheckboxGroup[key] !== '') {
        acc[key] = updatedCheckboxGroup[key];
      }
      return acc;
    }, {});

    setCheckboxGroup({ ...finalChecboxGroup });
  };

  const handleClear = () => {
    clearAllFilter();
    clear();
  };

  const handleFilterApply = () => {
    apply([
      search && { [selected]: search },
      checkboxGroup,
      date && { date: dayjs(date).format('YYYY-MM-DD') },
      dateRange && {
        start_date: dayjs(dateRange?.[0]).format('YYYY-MM-DD'),
        end_date: dayjs(dateRange?.[1]).format('YYYY-MM-DD')
      },
      amount && { transaction_range: selectAmountRange, transaction_amount: amount }
    ]);
  };

  const disabledDate = (current, disableToday = false) => {
    const customDate = '2023-03-01';

    const isOutOfRange = dayjs(current).isBefore(customDate) || dayjs(current).isAfter(Date.now());

    const isTodayDisabled = disableToday && dayjs(current).isSame(dayjs(), 'day');

    return isOutOfRange || isTodayDisabled;
  };

  const filtersTemplate = filters.map((i) => {
    return (
      <Panel style={{ backgroundColor: '#FFFFFF' }} header={i.label} key={i.label}>
        {i.type === 'DateRange' && (
          <RangePicker
            format="YYYY-MM-DD"
            style={{
              width: '100%',
              margin: '12px 0'
            }}
            value={dateRange}
            size="middle"
            disabledDate={(current) => disabledDate(current, props.disableToday)}
            onCalendarChange={(val) => {
              setDateRange(val);
            }}
          />
        )}
        {i.type === 'Date' && (
          <DatePicker
            format="YYYY-MM-DD"
            style={{
              width: '100%',
              margin: '12px 0'
            }}
            value={date}
            size="middle"
            disabledDate={(current) => disabledDate(current, props.disableToday)}
            onChange={(val) => {
              setDate(val);
            }}
          />
        )}
        {i.type === 'AmountRange' && (
          <div style={{ marginTop: '12px' }}>
            <EbzSelect
              defaultValue={AMOUNT_RANGE[0]?.value ?? ''}
              dropdownMatchSelectWidth={false}
              value={selectAmountRange}
              onChange={(val) => setSelectAmountRange(val)}
              options={AMOUNT_RANGE}
              style={{ width: '60%' }}
            />
            <div style={{ marginTop: '12px' }}>Amount</div>
            <Input
              id="amount"
              style={{ width: '60%', backgroundColor: '#ffffff' }}
              value={amount}
              onChange={(e) => setAmount(e?.target?.value)}
              type="number"
              suffix="₹"
            />
          </div>
        )}
        {!i.type && (
          <Checkbox.Group
            style={{
              width: '100%',
              paddingTop: '12px',
              paddingBottom: '18px'
            }}
            value={checkboxGroup[i.attr] ? checkboxGroup[i.attr].split(',') : []}
            onChange={(e) => handleCheck({ [i.attr]: e.join(',') })}
          >
            <Row gutter={[8, 8]} style={{ width: '100%' }}>
              {i.data.map((j) => {
                return (
                  <Col span={12} key={j.label}>
                    <Checkbox value={j.value}>{j.label}</Checkbox>
                  </Col>
                );
              })}
            </Row>
          </Checkbox.Group>
        )}
      </Panel>
    );
  });

  return (
    <>
      <Space direction="vertical" style={{ width: '100%' }}>
        <p style={{ margin: '0px' }}>Search</p>
        <Input.Group compact>
          <EbzSelect
            defaultValue={selected}
            style={{
              width: 'max-content'
            }}
            dropdownMatchSelectWidth={false}
            onChange={handleSelected}
            options={searchParams}
          />
          <Input
            style={{ width: '45%', backgroundColor: '#ffffff', height: '32px' }}
            value={search}
            onChange={handleSearch}
          />
        </Input.Group>
      </Space>
      {filters.length > 0 && (
        <Space direction="vertical" style={{ width: '100%', marginTop: '40px' }}>
          <p style={{ margin: '0px' }}>Filters</p>
          <EbzCollapse
            bordered={false}
            expandIconPosition="end"
            style={{ width: '100%', backgroundColor: '#FFFFFF' }}
          >
            {filtersTemplate}
          </EbzCollapse>
        </Space>
      )}
      <Space size="small" style={{ marginTop: '40px', display: 'flex', justifyContent: 'end' }}>
        <EbzButton onClick={handleClear}>Clear</EbzButton>
        <Button
          type="primary"
          style={{ boxShadow: '0px 3px 6px #0000000f' }}
          onClick={handleFilterApply}
          disabled={isApplyDisabled}
        >
          Apply
        </Button>
      </Space>
    </>
  );
}

EbzFilterGroup.propTypes = {
  searchParams: PropTypes.instanceOf(Array).isRequired,
  filters: PropTypes.instanceOf(Array).isRequired,
  disableToday: PropTypes.bool,
  apply: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired
};
EbzFilterGroup.defaultProps = {
  disableToday: false
};

export default EbzFilterGroup;
